const Property = {
  na: 0,
  residential: 1,
  commercial: 2
};

export default Property;
